var map = {
	"./AEXI_Logo.png": "./src/assets/img/application/AEXI_Logo.png",
	"./RVO_Logo.png": "./src/assets/img/application/RVO_Logo.png",
	"./TA_CMYK.png": "./src/assets/img/application/TA_CMYK.png",
	"./Trade-Advisory-Logo2.png": "./src/assets/img/application/Trade-Advisory-Logo2.png",
	"./bird-ship.jpg": "./src/assets/img/application/bird-ship.jpg",
	"./tiq_logo.png": "./src/assets/img/application/tiq_logo.png",
	"./trade-dsm-splash.png": "./src/assets/img/application/trade-dsm-splash.png",
	"./trade-icon-small.png": "./src/assets/img/application/trade-icon-small.png",
	"./trade-icon.png": "./src/assets/img/application/trade-icon.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/img/application sync recursive ^\\.\\/.*$";